export default [{
  path: '/ProjectPdf',//项目对接会邀请函 走出去邀请函 项目对接会安排
  name: 'pdfProPage',
  component: () => import('@/view/ProjectSpa/pdf.vue')
},{
  path: '/ProjectBooth',//项目填报 投资商报名
  name: 'boothProPage',
  component: () => import('@/view/ProjectSpa/booth.vue')
},{
  path: '/ProjectContact',//联络组委会项目组
  name: 'contactProPage',
  component: () => import('@/view/ProjectSpa/contact.vue')
},{
  path: '/ProjectWebsite',//相关投资机构网站
  name: 'websiteProPage',
  component: () => import('@/view/ProjectSpa/website.vue')
},{
  path: '/ProjectPro',//境内、境外项目
  name: 'ProProject',
  component: () => import('@/view/ProjectSpa/project.vue')
},{
  path: '/ProjectProDet',//境内、境外项目详情
  name: 'ProDetProject',
  component: () => import('@/view/ProjectSpa/proDet.vue')
},{
  path: '/ProjectNewsDet',//新闻详情
  name: 'NewsDetProject',
  component: () => import('@/view/ProjectSpa/LatestPageDetail.vue')
}]




// WEBPACK FOOTER //
// ./src/router/ProjectSpa.js